import * as React from 'react';
import { TextValidity } from '../contentActions/emailDownstreamUsers/ComposeEmailDialogContent';

export type TextValidityWithText = {
  readonly text: string;
  readonly textValidity: TextValidity;
}

function validateText(text: string, maximum: number): TextValidity {
  if (text.length > maximum) {
    return 'overflow';
  }

  if (text.replace(/\s/g, '') === '') {
    return 'empty';
  }

  return 'valid';
}

export function useText<T extends HTMLTextAreaElement | HTMLInputElement>(initial: string, maxLen: number) {
  const [text, setText] = React.useState<TextValidityWithText>({ text: '', textValidity: 'initial' });
  const handleTextChange = React.useCallback((event: React.ChangeEvent<T>) => {
    const bodyText = event.target.value;
    const isBodyValid = validateText(bodyText, maxLen);
    setText({
      text: bodyText,
      textValidity: isBodyValid,
    });
  }, [maxLen]);

  return { text, handleTextChange }
}
